// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__JzL8O","inner":"Footer_inner__1aqAA","nextIcon":"Footer_nextIcon__2VkRJ","innerLeft":"Footer_innerLeft__2EOMT"};